import { animate, AnimationPlaybackControls, useMotionValue } from "framer-motion";
import React from "react";
import { useCallbackRef } from "../../../hooks/useCallbackRef";

const useDynamicWinnerAnimation = ({
  duration: externalDuration,
  onRepeat,
  onWinner,
}: {
  duration: number;
  onRepeat: () => boolean;
  onWinner: () => void;
}) => {
  const transformY = useMotionValue<string>("-100%");
  const currentDuration = React.useRef<number>(externalDuration);
  const controlsRef = React.useRef<AnimationPlaybackControls | null>(null);
  const externalDurationRef = React.useRef<number>(externalDuration);
  const onWinnerRef = useCallbackRef(onWinner);
  const onRepeatRef = useCallbackRef(onRepeat);

  React.useEffect(() => {
    externalDurationRef.current = externalDuration;
  }, [externalDuration]);

  React.useEffect(() => {
    const startAnimation = (isWinner: boolean) => {
      controlsRef.current = animate(transformY, ["-100%", isWinner ? "0%" : "100%"], {
        repeat: isWinner ? 0 : Infinity,
        ease: "linear",
        duration: currentDuration.current,
        onComplete: () => {
          isWinner && onWinnerRef();
        },
        onRepeat: () => {
          if (isWinner) return;

          const nextOneWins = onRepeatRef();

          if (currentDuration.current === externalDurationRef.current && !nextOneWins) return;

          currentDuration.current = externalDurationRef.current;
          controlsRef.current?.stop();
          startAnimation(nextOneWins);
        },
      });
    };

    startAnimation(false);

    return () => {
      controlsRef.current?.stop();
    };
  }, [onRepeatRef, onWinnerRef, transformY]);

  return transformY;
};

export default useDynamicWinnerAnimation;
